import isApiError from "@insite/client-framework/Common/isApiError";
import { createHandlerChainRunner, HasOnException, HasOnSuccess } from "@insite/client-framework/HandlerCreator";

import { CrossReferenceLookupModel } from "@tIntermatic/Types/CrossReferenceLookupModel";

import {
    getCrossReferenceLookupCollection,
    GetCrossReferenceLookupParameter,
} from "@tIntermatic/Services/ProductCrossReferenceService";
import { CustomApiHandler } from "@tIntermatic/Store/CustomHandlerCreator";

type Parameter = GetCrossReferenceLookupParameter & HasOnSuccess<CrossReferenceLookupModel> & HasOnException<string>;

type HandlerType = CustomApiHandler<Parameter, CrossReferenceLookupModel>;

export const DispatchBeginLoadProducts: HandlerType = props => {
    props.dispatch({
        type: "Data/Products/BeginLoadCrossReferenceLookUp",
        parameter: props.parameter,
    });
};

export const PopulateApiParameter: HandlerType = props => {
    const { onSuccess, onException, ...parameter } = props.parameter;
    props.apiParameter = parameter;
};

export const RequestDataFromApi: HandlerType = async props => {
    try {
        props.apiResult = await getCrossReferenceLookupCollection(props.apiParameter);
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            props.parameter.onException?.(error.errorJson.message);
            return false;
        }
        throw error;
    }
};

export const DispatchCompleteLoadProducts: HandlerType = props => {
    props.dispatch({
        type: "Data/Products/CompleteLoadCrossReferenceLookUp",
        result: props.apiResult,
    });
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    props.parameter.onSuccess?.(props.apiResult!);
};

export const chain = [
    PopulateApiParameter,
    DispatchBeginLoadProducts,
    RequestDataFromApi,
    DispatchCompleteLoadProducts,
    ExecuteOnSuccessCallback,
];

export const getCrossReferenceLookup = createHandlerChainRunner(chain, "GetCrossReferenceLookup");
export default getCrossReferenceLookup;
